var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('download-excel',{staticClass:"button",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"name":"UserInfo.xlsx"}},[_c('button',[_vm._v("导出数据")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }